import { Directory, Filesystem } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { Platform } from '@ionic/angular';
import { inject, Injectable } from '@angular/core';
import { CARODocument } from '../models/document.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentConverter {

    private platform: Platform = inject(Platform);

    public async downloadPDF(caroDocument: CARODocument): Promise<void> {
        const source = caroDocument.base64;
        const documentFileName = caroDocument.documentName ?? 'download';

        const isNative =
            this.platform.is('capacitor') ||
            this.platform.is('android') ||
            this.platform.is('ios');

        if (!isNative) {
            const link = document.createElement('a');
            link.href = source;
            link.download = `${documentFileName}.pdf`;
            link.click();
            return;
        }

        // Native path: write the base64 payload into the app's data
        // directory and hand the file off to the OS's default viewer.
        // `@capacitor/filesystem` accepts the base64 string directly when
        // encoding is omitted, so we don't need to convert to a Blob.
        const base64Data = source.replace(/^data:application\/pdf;base64,/, '');

        try {
            const writeResult = await Filesystem.writeFile({
                path: documentFileName,
                data: base64Data,
                directory: Directory.Data,
                recursive: true
            });

            await FileOpener.open({
                filePath: writeResult.uri,
                contentType: 'application/pdf'
            });
        } catch (error) {
            console.error('[DocumentConverter] downloadPDF() - error writing or opening file', error);
        }
    }
}
